function isDev() { return !process.env.NODE_ENV || process.env.NODE_ENV === 'development' }

const baseUrl = isDev() ? "http://localhost:3017" : ""

const defaultHeaders = { 'Content-Type': 'application/json', 'Accept-Language': navigator.language }

export { baseUrl, defaultHeaders }